import { QueryClient } from '@tanstack/react-query';

// SWR defaults: paint instantly from cache, always revalidate on mount/focus.
// In-memory only (no persistence) — see the client-side-caching design spec.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      gcTime: 5 * 60 * 1000,
      refetchOnMount: true,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});

export default queryClient;
